@if (loaderIcon | async) {
    <app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-semibold">Check Layout</h5>
            </div>
            <hr />
            <form [formGroup]="checkLayoutForm">
                <div class="row g-4">
                    <div class="col-md-6">
                        <div class="card p-3 h-100">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0">Check Position</h6>
                                <div class="form-check"> 
                                    <input class="form-check-input" type="checkbox" id="visibleCheck" formControlName="CheckFieldVisible" (change)="updateControlProperties($event, 'CheckFieldVisible')">
                                    <label class="form-check-label" for="visibleCheck">Visible</label>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label">Check Position in Sheet</label>
                                <select class="form-select" formControlName="CheckPositionInSheet" (change)="changeCheckPositionInSheet($event.target.value)">
                                    @for (checkPosition of checkPrintPositions; track $index) {
                                        @if (checkPosition.Visible) {
                                            <option [value]="checkPosition.Id">{{checkPosition.Name}}</option>
                                        }
                                    }
                                </select>
                            </div>

                            <div>
                                <label class="form-label">Check Fields</label>
                                <select class="form-select" formControlName="CheckFieldId" (change)="changeCheckFields($event.target.value, null, true)">
                                    <option [value]='null'>Select</option>
                                    @for (checkFieldControl of checkFieldControlsList; track $index) {
                                        @if (checkFieldControl && checkFieldControl.IsVisible) {
                                            <option [value]="checkFieldControl.ControlName">{{checkFieldControl.ControlCaption}}</option>
                                        }
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card p-3 h-100">
                            <h6 class="mb-3">Field Location</h6>

                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label class="form-label">X-Position</label>
                                    <input type="text" class="form-control" formControlName="FieldLocationXPosition" (change)="updateControlProperties($event, 'FieldLocationXPosition')">
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Y-Position</label>
                                    <input type="text" class="form-control" formControlName="FieldLocationYPosition" (change)="updateControlProperties($event, 'FieldLocationYPosition')">
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Line Size</label>
                                    <select class="form-select" formControlName="FieldLocationLineSize" (change)="updateControlProperties($event, 'FieldLocationLineSize')">
                                        @for (lineSize of fieldLineSize; track $index) {
                                            <option [value]="lineSize.Id">{{lineSize.Name}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Line Length</label>
                                    <input type="text" class="form-control" maxlength="6" onkeypress="return event.charCode >= 48 && event.charCode <= 57" formControlName="FieldLocationLineLength"
                                     (change)="updateControlProperties($event, 'FieldLocationLineLength')">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row g-4">
                    <div class="col-md-6">
                        <div class="card p-3 h-100 mt-2">
                            <h6 class="mb-3">Field properties</h6>

                            <div class="mb-3">
                                <label class="form-label">Field Selected</label>
                                <input type="text" class="form-control" formControlName="FieldSelected">
                            </div>

                            <div>
                                <label class="form-label">Field Text</label>
                                <input type="text" class="form-control" formControlName="FieldText" maxlength="100">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card p-3 h-100 mt-2">
                            <h6 class="mb-3">Actions</h6>

                            <div class="d-grid gap-2">
                                <button class="btn btnAS-outline-secondary" (click)="restoreToDefault()">Restore to Default</button>
                                <button class="btn btnAS" (click)="exportDiagram()">Print Sample Check</button>
                            </div>

                            <div class="mt-3">
                                <select class="form-control" formControlName="PrintOrientation">
                                    @for (orientation of printOrientation; track $index) {
                                        <option [value]="orientation.Id">{{orientation.Name}}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-start">
                        <div class="card p-3 mt-3">
                            <div class="d-flex align-items-center mb-3">
                                <h6 class="mb-0 me-3">Font Settings</h6>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="changeFont" formControlName="ChangeFontSettings" (change)="changeFontSettings($event.target.checked)">
                                    <label class="form-check-label" for="changeFont">
                                        Change Font Settings
                                    </label>
                                </div>
                            </div>

                            <div class="row g-3">
                                <div class="col-md-4">
                                    <select class="form-select" formControlName="FontNameId" (change)="updateControlProperties($event, 'FontNameId')">
                                        @for (item of fontNameList; track $index) {
                                            <option [value]="item.Id">{{item.Name}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <select class="form-select" formControlName="FontStyleId" (change)="updateControlProperties($event, 'FontStyleId')">
                                        @for (item of fontStyleList; track $index) {
                                            <option [value]="item.Id">{{item.Name}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <select class="form-select" formControlName="FontSize" (change)="updateControlProperties($event, 'FontSize')">
                                        @for (item of fontSizeList; track $index) {
                                            <option [value]="item">{{item}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-start">
                        <div class="check-card bg-white">
                            <div class="check-body">
                                <ejs-diagram #diagramDynamic id="diagramDynamic" width="100%" height="400px" [rulerSettings]='rulerSettings'
                                [scrollSettings]='scrollSettings' [pageSettings] ='pageSettings' 
                                       [selectedItems]="selectedItems" (click)="clickDiagramNode($event)">
                                </ejs-diagram>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end my-2">
                        <ejs-tooltip id='tipCheckLayout' target="#btnCheckLayoutSave" position="TopCenter" (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" id="btnCheckLayoutSave" [userPermissionHandler]="editPermissionHandlerData" (click)="saveCheckLayout()">Save</button>
                        </ejs-tooltip>
                        <button class="btn btn-orange" (click)="btnCancel()">Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal -->
    <div class="modal fade" id="printDiagramModal" #printDiagramModal data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row mb-3">
                        <div class="col-12 text-start mt-2">
                            <ejs-diagram #diagramPrint id="diagramPrint" width="100%" height="1600px" [rulerSettings]='rulerSettings' [scrollSettings]='scrollSettings' [pageSettings] ='pageSettings' 
                                [selectedItems]="selectedItems">
                            </ejs-diagram>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
